module.exports = __webpack_public_path__ + "img/smart_scale_pairing_mode.13a55b8b.png";